export let UserProfile = {
  ADMIN: {text: 'Administrador', value: 'Administrator'},
  USER: {text: 'Associado', value: 'User'},
  MEMBER: {text: 'Membro da Comissão', value: 'Member'},
}
